import axios from "axios";

import { userTokenUpdate, updateAccountSuccess } from "./user";
import { getAuthHeader } from "../headers";

const userId = "67036755";
const albumIds = {
	mandatory: "5571666",
	traineeMandatory: "5604497",
	elective: "5571668"
};

// ===================================================================================
//  GET TRAINING VIDEOS FROM VIMEO
// ===================================================================================
export const trainingVideosLoading = videoType => {
	return {
		type: "TRAINING_VIDEOS_ARE_LOADING",
		videoType
	};
};

export const trainingVideosError = (error, videoType) => {
	return {
		type: "TRAINING_VIDEOS_HAS_ERROR",
		error,
		videoType
	};
};

export const trainingVideosSuccess = (data, videoType) => {
	return {
		type: "TRAINING_VIDEOS_SUCCESS",
		data,
		videoType
	};
};

export function getTrainingVideos(albumType, max = 4) {
	return dispatch => {
		dispatch(trainingVideosLoading(albumType));

		// Get the album id by the type requested ("elective": 124 or whatever)
		const albumId = albumIds[albumType];

		// Set auth header for api
		const AUTH_HEADER = {
			Authorization: `Bearer ${process.env.REACT_APP_VIMEO_TOKEN}`
		};

		return axios
			.get(`https://api.vimeo.com/users/${userId}/albums/${albumId}/videos?per_page=${max}`, {
				headers: AUTH_HEADER
			})
			.then(response => {
				if (response.data.status && response.data.status !== 200) {
					dispatch(trainingVideosError(response.data.errors, albumType));
				} else {
					dispatch(trainingVideosSuccess(response.data, albumType));
					return Promise.resolve(response);
				}
			})
			.catch(err => {
				dispatch(trainingVideosError(err.response.data.message, albumType));
			});
	};
}

// ===================================================================================
//  VIDEO WATCHED
// ===================================================================================
export const videoWatchedLoading = videoType => {
	return {
		type: "VIDEO_WATCHED_LOADING",
		videoType
	};
};

export const videoWatchedError = error => {
	return {
		type: "VIDEO_WATCHED_HAS_ERROR",
		error
	};
};

export const videoWatchedSuccess = data => {
	return {
		type: "VIDEO_WATCHED_SUCCESS",
		data
	};
};

export function setVideoWatched(videoId) {
	return (dispatch, getState) => {
		dispatch(videoWatchedLoading());

		// Set params
		const params = { videoId };

		return axios
			.post(process.env.REACT_APP_API_URL + `video-watched`, params, {
				headers: getAuthHeader(getState().user)
			})
			.then(response => {
				if (response.data.status && response.data.status !== 200) {
					dispatch(videoWatchedError(response.data.errors));
				} else {
					dispatch(videoWatchedSuccess(response.data));

					if (!!response.data.token) {
						dispatch(userTokenUpdate("reviewer", response.data.token));
						dispatch(updateAccountSuccess(response.data.reviewer));
					}

					return Promise.resolve(response);
				}
			})
			.catch(err => {
				dispatch(videoWatchedError(err.response.data.message));
			});
	};
}

// ===================================================================================
//  GET VIDEO SURVEYS
// ===================================================================================
export const videoSurveysLoading = videoType => {
	return {
		type: "VIDEO_SURVEYS_LOADING",
		videoType
	};
};

export const videoSurveysError = error => {
	return {
		type: "VIDEO_SURVEYS_HAS_ERROR",
		error
	};
};

export const videoSurveysSuccess = data => {
	return {
		type: "VIDEO_SURVEYS_SUCCESS",
		data
	};
};

export function getVideoSurveys() {
	return (dispatch, getState) => {
		dispatch(videoSurveysLoading());

		return axios
			.get(process.env.REACT_APP_API_URL + `video-surveys`, {
				headers: getAuthHeader(getState().user)
			})
			.then(response => {
				if (response.data.status && response.data.status !== 200) {
					dispatch(videoSurveysError(response.data.errors));
				} else {
					dispatch(videoSurveysSuccess(response.data));
				}
			})
			.catch(err => {
				dispatch(videoSurveysError(err.response.data.message));
			});
	};
}



// WEBPACK FOOTER //
// ./src/store/actions/trainingVideos.js